import { Product } from '@dfds-frontend/tracking'
import { seabookRouteMap } from '@dfds-pax/utils'

import { TrackingData } from '../_actions/getTrackingData'

export const getProducts = (data: TrackingData): Product[] | null => {
  const offerCode = FindOfferCode(data)
  const products: Product[] = []

  data.departures.forEach((departure, index) => {
    const seabookRouteCode =
      seabookRouteMap.find((r) => r.route === `${departure?.departurePort}-${departure?.arrivalPort}`)?.seabook ?? 'UNDEFINED'

    const direction = data.departures.length === 2 ? (index === 1 ? 'Return' : 'Outbound') : 'Oneway'

    const product = mapToTrackingProduct(
      data.trailerCode ? `${data.vehicleCode ?? 'NCAR'}|${data.trailerCode}` : `${data.vehicleCode ?? 'NCAR'}`,
      seabookRouteCode,
      departure.departureDate,
      departure.departureTime!, // at this time departure will be set and not undefined, but to satisfy the type we assert it with !
      offerCode ?? 'UNDEFINED',
      departure.ticketPrice,
      1,
      departure.productCode ?? '',
      'SeabookDeparture',
      direction
    )
    products.push(product)

    departure.addons.forEach((addon) => {
      if (addon.parentAddonCode !== 'PET') {
        const addonProduct = mapToTrackingProduct(
          addon.addonCode,
          seabookRouteCode,
          departure.departureDate,
          departure.departureTime!, // at this time departure will be set and not undefined, but to satisfy the type we assert it with !
          addon.unitPriceStructure.offer && offerCode ? offerCode : 'UNDEFINED',
          addon.unitPriceStructure.offer?.price ?? addon.unitPriceStructure.basePrice,
          addon.quantity,
          departure.productCode ?? '',
          'SeabookExtra',
          direction
        )
        products.push(addonProduct)
      } else {
        const petProduct = mapToTrackingProduct(
          addon.addonCode,
          seabookRouteCode,
          departure.departureDate,
          departure.departureTime!, // at this time departure will be set and not undefined, but to satisfy the type we assert it with !
          'UNDEFINED',
          addon.unitPriceStructure.basePrice,
          addon.quantity,
          departure.productCode ?? '',
          'SeabookPet',
          direction
        )
        products.push(petProduct)
      }
    })
  })

  return products
}

export function FindOfferCode(data: TrackingData): string {
  const depOffer = data.departures.find((d) => d.offerCode)?.offerCode
  if (depOffer) return depOffer

  let addonOfferCode
  for (const departure of data.departures) {
    for (const addon of departure.addons) {
      if (addon.unitPriceStructure.offer?.code) {
        addonOfferCode = addon.unitPriceStructure.offer.code
        break
      }
    }
    if (addonOfferCode) break
  }
  return addonOfferCode ?? ''
}

const mapToTrackingProduct = (
  code: string,
  routeCode: string,
  departureDate: string,
  departureTime: string,
  offerCode: string,
  price: number,
  quantity: number,
  productCode: string,
  brand: 'SeabookExtra' | 'SeabookDeparture' | 'SeabookPet',
  direction: 'Return' | 'Outbound' | 'Oneway'
): Product => {
  const departureDateString: string = departureDate?.replace(/-/gm, '')
  const departureTimeString: string = departureTime?.replace(':', '')

  const _offerCode = offerCode || 'UNDEFINED'

  return {
    brand: brand,
    category: `${routeCode}/${departureDateString}/${departureTimeString}/${_offerCode}/${productCode}`, // DKDV/20220629/0800/OFFERCODE OR UNDEFINED/EPREMIUM
    id: code,
    name: code,
    price: price?.toString(),
    quantity: quantity.toString(),
    variant: direction,
  }
}
